// tslint:disable:max-line-length

import React from 'react';

import api from '../../../api';
import { CalendarSourceStatus } from '../../../data/entities/calendar-source';
import { useDebouncedCallback } from '../../helpers/hooks';
import { FormInput, FormLabel } from '../form';
import { CalendarSourceUrlStatus } from './CalendarSourceUrlStatus';

interface ICalendarSourceInputBlockProps {
	name: string;
	source: string;
	onChangeName: (source: string) => any;
	onChangeSource: (source: string) => any;
	onChangeStatus: (status: CalendarSourceStatus) => any;
	sourceStatus?: CalendarSourceStatus;
}

export const CalendarSourceInputBlock: React.FC<ICalendarSourceInputBlockProps> = (props) => {
	const { name, source, sourceStatus, onChangeName, onChangeSource, onChangeStatus } = props;
	const [loading, setLoading] = React.useState(false);

	const unbouncedSetSource = (url: string) => {
		const validate = async () => {
			if (!loading) {
				setLoading(true);
				// We need to url-encode the whole URL so all potential query parameters are passed properly in the validate endpoint URL
				const encodedUrl = encodeURIComponent(url);
				const data = await api.icalValidaton.validateIcal(encodedUrl);
				onChangeStatus(data.success ? 'success' : 'error');
				setLoading(false);
			}
		};
		onChangeStatus('pending');
		onChangeSource(url);
		validate();
	};

	const setSource = useDebouncedCallback(unbouncedSetSource, 500);

	return <div className="calendar-source-input__container">
		<FormLabel htmlFor={`calendar-source-input__name`}>Calendar name</FormLabel>
		<FormInput
			id={`calendar-source-input__name`}
			defaultValue={name}
			widthtype="full"
			onChange={(e) => onChangeName(e.target.value)} />
		<FormLabel htmlFor={`calendar-source-input__url`}>External calendar link</FormLabel>
		<FormInput
			id={`calendar-source-input__url`}
			defaultValue={source}
			is-valid={sourceStatus === 'error' ? 'false' : 'true'}
			widthtype="full"
			onChange={(e) => setSource(e.target.value)} />
		{sourceStatus && <CalendarSourceUrlStatus sourceState={sourceStatus} />}
	</div>;
};
